import { useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { AgeGate } from "./components/AgeGate";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { AppLayout } from "./components/layout/AppLayout";
import { STORAGE_KEY } from "./constants";
import { AdminPage } from "./pages/AdminPage";
import { CatalogPage } from "./pages/CatalogPage";
import { LegalPage } from "./pages/LegalPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { ProductPage } from "./pages/ProductPage";

function readAgeVerified(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export default function App() {
  const [verified, setVerified] = useState(readAgeVerified);
  const { pathname } = useLocation();

  if (!verified) {
    return <AgeGate onVerified={() => setVerified(true)} />;
  }

  if (pathname === "/admin") {
    return <AdminPage />;
  }

  return (
    <ErrorBoundary>
      <Routes>
        <Route element={<AppLayout />}>
          <Route index element={<CatalogPage />} />
          <Route path="product/:slug" element={<ProductPage />} />
          <Route path="terms" element={<LegalPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
